import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { ListBoxComponent } from './list-box.component';
import { ListBoxFilterPipe } from './list-box-filter.pipe';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [
    ListBoxComponent
  ],
  declarations: [
    ListBoxComponent,
    ListBoxFilterPipe
  ]
})
export class ListBoxModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/list-box/list-box.module.ts